<template>
    <div>
        <div class="g-hd">
            <div class="ttBox">
                <img class="back" src="../assets/jxwx/return.png" alt="" @click="backward()">
                <span class="tt">{{data.org}}</span>
            </div>
        </div>
        <div class="m-hd">
            <div>部门领导信息空缺</div>
            <div class="numBox">岗位
                <span class="num">{{gwNum}}</span>
            </div>
            <div class="numBox">人员
                <span class="num">{{ryNum}}</span>
            </div>
        </div>
        <ul class="list">
            <li>
                <div class="dep">部门名称 </div>
                <div class="gw">岗位</div>
                <div class="name">姓名</div>
            </li>
            <li v-for="item in data.noName1Deps" :key="item.id">
                <div class="dep">{{item.dep}}</div>
                <div class="gw">{{item.gw1 | isNull}}</div>
                <div class="name">{{item.name1 | isNull}}</div>
            </li>
        </ul>
        <div class="m-hd">
            <div>岗位上级领导空缺</div>
            <div class="numBox">岗位
                <span class="num">{{gwNum2}}</span>
            </div>
            <div class="numBox">人员
                <span class="num">{{ryNum2}}</span>
            </div>
        </div>
        <ul class="list">
            <li>
                <div class="dep">部门名称 </div>
                <div class="gw">岗位名称</div>
                <div class="gw2">上级岗位</div>
                <div class="name">姓名</div>
            </li>
            <li v-for="item in data.noName2Deps" :key="item.id">
                <div class="dep">{{item.dep}}</div>
                <div class="gw">{{item.gw1 | isNull}}</div>
                <div class="gw2">{{item.gw2 | isNull}}</div>
                <div class="name">{{item.name2 | isNull}}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        // token: {
        //     immediate: true,
        //     handler: function(val) {
        //         if (val) {
        //             // this.getResult(this.time);
        //             // this.getDailyCountData(this.time);
        //         }
        //     }
        // }
    },
    data() {
        return {
            data: this.$route.query.data,
            gwNum: 0,
            ryNum: 0,
            gwNum2: 0,
            ryNum2: 0
        };
    },
    filters: {
        isNull: function(val) {
            if (val == null) {
                return "/";
            } else {
                return val;
            }
        }
    },
    mounted() {
        //   this.getResult(this.time);
        //   this.getDailyCountData(this.time);
        this.getNum();
    },
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        getNum() {
            let that =this;
            this.data.noName1Deps.map(function(item) {
                if (item.gw1 == null) {
                    that.gwNum++;
                }
                if (item.name1 == null) {
                    that.ryNum++;
                }
            });
            this.data.noName2Deps.map(function(item) {
                if (item.gw2 == null) {
                    that.gwNum2++;
                }
                if (item.name2 == null) {
                    that.ryNum2++;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    padding: 2vw 0;
    color: #fff;
    background: #5584ff;
    .ttBox {
        display: flex;
        align-items: center;
        margin-left: 4vw;
        padding: 2vw 0;
        .back {
            width: 2vw;
            margin-right: 2.6vw;
        }
        .tt {
            margin-right: 4vw;
            font-size: 18px;
            color: #fff;
        }
    }
}
.m-hd {
    display: flex;
    padding: 2.7vw 3.2vw;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    font-size: 16px;
    .numBox {
        display: flex;
        align-items: center;
    }
    .num {
        display: inline-block;
        width: 11.7vw;
        height: 8.5vw;
        margin-left: 2vw;
        line-height: 8.5vw;
        color: #fff;
        background: #92c619;
        border-radius: 6px;
    }
}
.list {
    background: #fff;
    li:first-child {
        background: #e2eafe;
        border-bottom: none;
    }
    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 12.8vw;
        padding: 0 3.2vw;
        text-align: center;
        font-size: 14px;
        border-bottom: 1px solid #e0e0e0;

        .dep {
            width: 23.4vw;
        }
        .gw {
            width: 23.4vw;
        }
        .gw2 {
            width: 23.4vw;
        }
        .name {
            width: 23.4vw;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/hrReport/hrDetails.vue